export default __webpack_public_path__ + "static/media/duck.d98b4a8d.svg";